import { connectInfiniteHitsWithInsights } from "instantsearch.js/es/connectors";
import { provide, ref } from "vue";
export const useAisInfiniteHits = (widgetParams, id = "") => {
  const stateRef = ref();
  const renderInfiniteHits = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (isFirstRender) {
      provide(`infiniteHits-${id}`, stateRef);
    }
    return () => {
    };
  };
  const customInfiniteHits = connectInfiniteHitsWithInsights(renderInfiniteHits);
  const significantParams = {
    ...widgetParams,
    cache: false,
    transformItems: null
  };
  return {
    ...customInfiniteHits(widgetParams),
    $$widgetParams: significantParams,
    $$widgetId: id
  };
};
